import { faExpand } from '@fortawesome/free-solid-svg-icons'

import { cn } from '@/utils'

import { toggleFullscreen } from '@/utils/fullscreen'

import { RundownOutputControlButton } from '@/features/rundown-output/RundownOutputControlButton'

type RundownOutputControlsTypes = {
  mirrorVertically: boolean
  onMirrorVertically: () => void
  mirrorHorizontally: boolean
  onMirrorHorizontally: () => void
}

export function RundownOutputControls({
  mirrorVertically,
  onMirrorVertically,
  mirrorHorizontally,
  onMirrorHorizontally,
}: RundownOutputControlsTypes) {
  return (
    <div className="flex gap-1">
      <button
        className={cn([
          'h-10 w-10 rounded bg-gray-800/90 hover:bg-gray-800 transition-colors flex items-center justify-center',
          mirrorVertically && 'border border-green-500',
        ])}
        onClick={onMirrorVertically}
      >
        <img
          className="h-6 w-6 text-white"
          src="/img/mirror-icon.svg"
        />
      </button>
      <button
        className={cn([
          'h-10 w-10 rounded bg-gray-800/90 hover:bg-gray-800 transition-colors flex items-center justify-center',
          mirrorHorizontally && 'border border-green-500',
        ])}
        onClick={onMirrorHorizontally}
      >
        <img
          className="h-6 w-6 text-white rotate-90"
          src="/img/mirror-icon.svg"
        />
      </button>
      <RundownOutputControlButton
        tooltip="Toggle fullscreen"
        icon={faExpand}
        onClick={toggleFullscreen}
      />
    </div>
  )
}
